var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-sheet',{attrs:{"color":_vm.color,"height":"100%"}},[_c('v-row',{staticClass:"fill-height",attrs:{"align":"center","justify":"center"}},[_c('div',{staticClass:"display-3"},[_vm._v(_vm._s(_vm.slide))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }